import React from 'react'
import PropTypes from 'prop-types'
import { TabButtonFilled, TabButtonOutlined } from 'secondstep-components'

const AdminDashboardTabButton = ({
  className,
  isActive,
  label,
  onClick,
  onKeyPress,
  ultraWide,
  wide,
  width,
}) => {
  return (
    <div className={className}>
      {isActive && (
        <TabButtonFilled
          label={label}
          onClick={onClick}
          onKeyPress={onKeyPress}
          ultraWide={ultraWide}
          wide={wide}
          width={width}
        />
      )}
      {!isActive && (
        <TabButtonOutlined
          label={label}
          onClick={onClick}
          onKeyPress={onKeyPress}
          ultraWide={ultraWide}
          wide={wide}
          width={width}
        />
      )}
    </div>
  )
}

AdminDashboardTabButton.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  ultraWide: PropTypes.bool,
  wide: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default AdminDashboardTabButton
